import { useQuery } from "@tanstack/react-query"
import { api } from "@/api"
import { VoterRegistrationInfo } from "QuorumGrassroots/pages/campaign/voter-information/types"

const voterInfoKeys = {
    all: [{ _model: "voterInfo" }] as const,
    detail: (campaignId: string) => [{ ...voterInfoKeys.all[0], campaignId }] as const,
}

export const useVoterRegistrationInfo = (campaignId: string | undefined, hasError: boolean) => {
    return useQuery<VoterRegistrationInfo>({
        queryKey: voterInfoKeys.detail(campaignId || ""),
        queryFn: async () => api.get("/gotv/voter-registration-info/").then((resp) => resp.json()),
        retry: false,
        enabled: Boolean(campaignId) && !hasError,
        refetchOnWindowFocus: false,
        staleTime: Infinity,
    })
}
